import * as React from "react"

import { cn } from "src/lib/utils"
import { cva } from "class-variance-authority"

const inputVariants = cva(
  "file:text-foreground placeholder:text-muted-foreground selection:bg-primary-100 selection:text-primary-800 dark:bg-primary-100/20 border-primary-200 flex h-12 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:px-0 file:text-sm file:font-medium file:cursor-pointer sm:text-sm",
  {
    variants: {
      variant: {
        default:
          "focus-visible:border-primary-500 focus-visible:ring-primary-400/40 focus-visible:ring-[3px]",
        destructive:
          "border-destructive text-destructive aria-invalid:border-destructive focus-visible:border-destructive focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:border-destructive/60",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(inputVariants({ variant: "default" }), className)}
      {...props}
    />
  )
}

export { Input }
